const GiftCardActions = {
    UPDATE_MASTER: 'UPDATE_GIFT_CARD',
    UPDATE_PURCHASED: 'UPDATE_GIFT_CARD_PURCHASED',
    UPDATE_VALID_MESSAGE: 'UPDATE_VALID_MESSAGE',

}

export default GiftCardActions;